/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Owning extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Owning;


// WEBPACK FOOTER //
// ./src/routes/searchOwning/index.js